import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { CommonDialog, CommonButton } from '@/components/common'

export const CancelConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      title='Cancel Appointment?'
      persistent={false}
      actions={
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            width: '100%',
            justifyContent: 'center',
          }}
        >
          <CommonButton
            id='cancel-yes-btn'
            label='Yes'
            variant='primary'
            color='primary'
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
          />
          <CommonButton
            id='cancel-no-btn'
            label='No'
            variant='secondary'
            color='primary'
            onClick={onClose}
            disabled={loading}
          />
        </Box>
      }
    >
      <Box textAlign='center' py={2}>
        <Typography variant='body1' color='primary' sx={{ fontWeight: 500 }}>
          Are You Sure You Want to Cancel?
        </Typography>
      </Box>
    </CommonDialog>
  )
}

CancelConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}
